// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import accordion from "@keller/XDL/PreStyle/accordion";
import breadcrumbs from "@keller/XDL/PreStyle/breadcrumbs";
import breakpoints from "@keller/XDL/PreStyle/breakpoints";
import button from "@keller/XDL/PreStyle/button";
import checkbox from "@keller/XDL/PreStyle/checkbox";
import clickable from "@keller/XDL/PreStyle/clickable";
import colors from "@keller/XDL/PreStyle/colors";
import dataTable from "@keller/XDL/PreStyle/dataTable";
import datePicker from "@keller/XDL/PreStyle/datePicker";
import dynamicDropdown from "@keller/XDL/PreStyle/dynamicDropdown";
import fileUpload from "@keller/XDL/PreStyle/fileUpload";
import footer from "@keller/XDL/PreStyle/footer";
import formField from "@keller/XDL/PreStyle/formField";
import globalStyle from "@keller/XDL/PreStyle/globalStyle";
import header from "@keller/XDL/PreStyle/header";
import link from "@keller/XDL/PreStyle/link";
import lists from "@keller/XDL/PreStyle/lists";
import loadingSpinner from "@keller/XDL/PreStyle/loadingSpinner";
import menu from "@keller/XDL/PreStyle/menu";
import modal from "@keller/XDL/PreStyle/modal";
import overflowMenu from "@keller/XDL/PreStyle/overflowMenu";
import pagination from "@keller/XDL/PreStyle/pagination";
import radio from "@keller/XDL/PreStyle/radio";
import select from "@keller/XDL/PreStyle/select";
import shadows from "@keller/XDL/PreStyle/shadows";
import tab from "@keller/XDL/PreStyle/tab";
import tag from "@keller/XDL/PreStyle/tag";
import textArea from "@keller/XDL/PreStyle/textArea";
import toast from "@keller/XDL/PreStyle/toast";
import tooltip from "@keller/XDL/PreStyle/tooltip";
import typography from "@keller/XDL/PreStyle/typography";
import zIndex from "@keller/XDL/PreStyle/zIndex";
import { xBaseTheme } from "@keller/XDL/types";

export default {
    breakpoints,
    colors,
    // focus,
    shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    clickable,
    dataTable,
    datePicker,
    // drawer,
    dynamicDropdown,
    fileUpload,
    header,
    formField,
    // fieldSet,
    // icon,
    link,
    lists,
    // lazyImage,
    loadingSpinner,
    menu,
    modal,
    overflowMenu,
    pagination,
    // panelMenu,
    radio,
    select,
    // swatch,
    tab,
    tag,
    // textField,
    // tokenExFrame,
    textArea,
    toast,
    tooltip,
    footer
} as xBaseTheme;
